<div class="tooltip-content">
    <h2>{{ 'Atalhos de teclado para página de detalhes' | translate}}</h2>
    <ul>
        <li>Alt + "+": {{ 'Zoom in na imagem' | translate}}</li>
        <li>Alt + "-": {{ 'Zoom out na imagem' | translate}}</li>
        <li>Alt + "c": {{ 'Colapsar/mostrar imagem' | translate}}</li>
        <li>Alt + "p": {{ 'Ir para próxima receita' | translate}}</li>
        <li>Alt + "a": {{ 'Ir para receita anterior' | translate}}</li>
        <li>Alt + "i": {{ 'Abrir receita em outra página' | translate}}</li>
        <li>Alt + "d": {{ 'Limpa campo selecionado no formulário' | translate}}</li>
        <li>Alt + "q": {{ 'Remove campo de produto que está selecionado' | translate}}</li>
        <li>Alt + "w": {{ 'Adiciona campo de produto que está selecionado' | translate}}</li>
        <li>Alt + "f": {{ 'Remove todos produtos e posologia' | translate}}</li>
        <li>Alt + "s": {{ 'Remove campo de especialidade que está selecionado' | translate}}</li>
        <li>Alt + "e": {{ 'Adiciona campo de especialidade que está selecionado' | translate}}</li>
        <!--li>Alt + "w": {{ 'Fechar imagem 100%' | translate}}</li-->
        <li>Alt + "Enter": {{ 'Salvar receita' | translate}}</li>
        <li>Alt + "Backspace": {{ 'Voltar para listagem' | translate}}</li>
        <li>Alt + "r": {{ 'Rotacionar imagem' | translate}}</li>
        <li>Alt + "{{ 'seta para cima' | translate}}": {{ 'Movimentar imagem para cima' | translate}}</li>
        <li>Alt + "{{ 'seta para baixo' | translate}}": {{ 'Movimentar imagem para baixo' | translate}}</li>
        <li>Alt + "{{ 'seta para esquerda' | translate}}": {{ 'Movimentar imagem seta para esquerda' | translate}}</li>
        <li>Alt + "{{ 'seta para direita' | translate}}": {{ 'Movimentar imagem seta para direita' | translate}}</li>
        <li>Shift + "{{ 'seta para baixo' | translate}}": {{ 'Quando na lista de produto, saltar para o próximo campo produto.' | translate}}</li>
        <li>Shift + "{{ 'seta para cima' | translate}}": {{ 'Quando na lista de produto, retornar para o campo produto anterior.' | translate}}</li>
        <li>Shift + "p": {{ 'Focar no status do produto (se inválido)' | translate}}</li>
        <li>Shift + "m": {{ 'Focar no status do médico (se inválido)' | translate}}</li>
    </ul>
</div>